import { Component, Inject, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExcelService } from 'src/app/core/api/services';
import { ApiNotificationService } from 'src/app/core/services/api-notification.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';


import { BaseDownloadExcelPageComponent } from 'src/app/pages/shared/base/components/base-download-excel-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";



@Component({
    selector: 'app-create-transactions-excel-dialog',
    templateUrl: './create-transactions-excel-dialog.component.html',
    styleUrls: ['./create-transactions-excel-dialog.component.scss'],
    imports: [
        BaseFormModule,
        ModalTitleComponent
    ]
})
export class CreateTransactionsExcelDialogComponent
  extends BaseDownloadExcelPageComponent
  implements OnInit
{
  dynamicTabService = inject(DynamicTabService);

  constructor(
    protected currentService: ExcelService,
    public apiNotificationService: ApiNotificationService,
    protected dialogRef: MatDialogRef<CreateTransactionsExcelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.comparisonObjects = data?.comparisonObjects;
    this.sortObject = data?.sortObject;
    this.methodName = data?.methodName;
  }

  //#region Api

  getExcel() {
    this.unSubs();
    this.loading = true;
    this.currentService[this.methodName]({
      body: {
        comparisonObjects: this.comparisonObjects,
        orders: this.sortObject,
        title: this.title,
      },
    })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDownloadExcelObserver);
  }

  //#endregion
}
